/**
Copyright (c) 2022-2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

// List of trusted email domains that are always allowed
// These bypass the disposable email check
const TRUSTED_EMAIL_DOMAINS: string[] = [
  // Major free email providers
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'outlook.in',
  'hotmail.com',
  'hotmail.co.uk',
  'hotmail.fr',
  'hotmail.de',
  'hotmail.it',
  'hotmail.es',
  'live.com',
  'live.co.uk',
  'live.in',
  'msn.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.co.in',
  'yahoo.in',
  'yahoo.fr',
  'yahoo.de',
  'yahoo.it',
  'yahoo.es',
  'yahoo.ca',
  'yahoo.com.au',
  'yahoo.com.br',
  'ymail.com',
  'rocketmail.com',
  'aol.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'protonmail.com',
  'protonmail.ch',
  'proton.me',
  'pm.me',
  'zoho.com',
  'zohomail.com',
  'zoho.in',
  'fastmail.com',
  'fastmail.fm',
  'tutanota.com',
  'tutanota.de',
  'tutamail.com',
  'tuta.io',
  'gmx.com',
  'gmx.net',
  'gmx.de',
  'gmx.at',
  'gmx.ch',
  'web.de',
  'mail.com',
  'email.com',
  'usa.com',
  'myself.com',
  'consultant.com',
  'engineer.com',
  'programmer.com',
  'techie.com',

  // Regional providers
  'rediffmail.com',
  'rediff.com',
  'sify.com',
  'vsnl.net',
  'yandex.com',
  'yandex.ru',
  'mail.ru',
  'inbox.ru',
  'list.ru',
  'bk.ru',
  'qq.com',
  '163.com',
  '126.com',
  'sina.com',
  'sina.cn',
  'naver.com',
  'daum.net',
  'hanmail.net',

  // Business/Professional
  'hey.com',
  'basecamp.com',
  'slack.com',

  // Educational (common patterns)
  'edu',
  'ac.uk',
  'ac.in',
  'edu.au',
  'edu.cn',

  // ISP email providers
  'att.net',
  'sbcglobal.net',
  'bellsouth.net',
  'charter.net',
  'comcast.net',
  'cox.net',
  'verizon.net',
  'earthlink.net',
  'juno.com',
  'netzero.net',
  'btinternet.com',
  'virginmedia.com',
  'sky.com',
  'talktalk.net',
  'orange.fr',
  'free.fr',
  'sfr.fr',
  'laposte.net',
  't-online.de',
  'arcor.de',
  'freenet.de',
  'libero.it',
  'virgilio.it',
  'tin.it',
  'alice.it',
  'telefonica.net',
  'terra.com.br',
  'uol.com.br',
  'bol.com.br',
  'ig.com.br',
  'bigpond.com',
  'optusnet.com.au',

  // Common corporate domain patterns (TLDs)
  'company.com',
  'corp.com',
  'business.com',

  // Educational institutions
  'mitmuzaffarpur.org',
];

// List of known disposable email domains
// This list is not exhaustive but covers the most common ones
const DISPOSABLE_EMAIL_DOMAINS: string[] = [
  // Popular disposable email services
  '10minutemail.com',
  '10minutemail.net',
  '10minutemail.org',
  '10minmail.com',
  '20minutemail.com',
  '33mail.com',
  'anonbox.net',
  'anonymbox.com',
  'antispam.de',
  'binkmail.com',
  'bobmail.info',
  'bofthew.com',
  'bugmenot.com',
  'bumpymail.com',
  'buyusedlibrarybooks.org',
  'byom.de',
  'cko.kr',
  'cool.fr.nf',
  'correo.blogos.net',
  'cosmorph.com',
  'courriel.fr.nf',
  'courrieltemporaire.com',
  'curryworld.de',
  'cust.in',
  'dacoolest.com',
  'dandikmail.com',
  'deadaddress.com',
  'despam.it',
  'despammed.com',
  'devnullmail.com',
  'dfgh.net',
  'digitalsanctuary.com',
  'discardmail.com',
  'discardmail.de',
  'disposable.com',
  'disposableaddress.com',
  'disposableemailaddresses.com',
  'disposableinbox.com',
  'dispose.it',
  'disposeamail.com',
  'disposemail.com',
  'dispostable.com',
  'dm.w3internet.co.uk',
  'dodgeit.com',
  'dodgemail.de',
  'dodgit.com',
  'dontreg.com',
  'dontsendmespam.de',
  'drdrb.com',
  'dump-email.info',
  'dumpandjunk.com',
  'dumpmail.de',
  'dumpyemail.com',
  'e4ward.com',
  'easytrashmail.com',
  'einmalmail.de',
  'email60.com',
  'emaildienst.de',
  'emailgo.de',
  'emailias.com',
  'emailigo.de',
  'emailinfive.com',
  'emaillime.com',
  'emailmiser.com',
  'emailsensei.com',
  'emailtemporanea.com',
  'emailtemporanea.net',
  'emailtemporar.ro',
  'emailtemporario.com.br',
  'emailthe.net',
  'emailtmp.com',
  'emailto.de',
  'emailwarden.com',
  'emailx.at.hm',
  'emailxfer.com',
  'emz.net',
  'enterto.com',
  'ephemail.net',
  'etranquil.com',
  'etranquil.net',
  'etranquil.org',
  'evopo.com',
  'explodemail.com',
  'fakeinbox.com',
  'fakeinformation.com',
  'fansworldwide.de',
  'fastacura.com',
  'fastchevy.com',
  'fastchrysler.com',
  'fastkawasaki.com',
  'fastmazda.com',
  'fastmitsubishi.com',
  'fastnissan.com',
  'fastsubaru.com',
  'fastsuzuki.com',
  'fasttoyota.com',
  'fastyamaha.com',
  'filzmail.com',
  'fizmail.com',
  'flyspam.com',
  'fr33mail.info',
  'frapmail.com',
  'friendlymail.co.uk',
  'front14.org',
  'fuckingduh.com',
  'fudgerub.com',
  'garliclife.com',
  'gehensiull.com',
  'get1mail.com',
  'get2mail.fr',
  'getairmail.com',
  'getmails.eu',
  'getonemail.com',
  'getonemail.net',
  'giantmail.de',
  'girlsundertheinfluence.com',
  'gishpuppy.com',
  'goemailgo.com',
  'gorillaswithdirtyarmpits.com',
  'gotmail.com',
  'gotmail.net',
  'gotmail.org',
  'gowikibooks.com',
  'gowikicampus.com',
  'gowikicars.com',
  'gowikifilms.com',
  'gowikigames.com',
  'gowikimusic.com',
  'gowikinetwork.com',
  'gowikitravel.com',
  'gowikitv.com',
  'great-host.in',
  'greensloth.com',
  'grr.la',
  'gsrv.co.uk',
  'guerillamail.biz',
  'guerillamail.com',
  'guerillamail.de',
  'guerillamail.info',
  'guerillamail.net',
  'guerillamail.org',
  'guerrillamail.biz',
  'guerrillamail.com',
  'guerrillamail.de',
  'guerrillamail.info',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamailblock.com',
  'gustr.com',
  'harakirimail.com',
  'hat-gansen.de',
  'hatespam.org',
  'herp.in',
  'hidemail.de',
  'hidzz.com',
  'hmamail.com',
  'hochsitze.com',
  'hopemail.biz',
  'hotpop.com',
  'hulapla.de',
  'ieatspam.eu',
  'ieatspam.info',
  'ieh-mail.de',
  'ihateyoualot.info',
  'iheartspam.org',
  'imails.info',
  'imgof.com',
  'imgv.de',
  'imstations.com',
  'inbax.tk',
  'inbox.si',
  'inboxalias.com',
  'inboxclean.com',
  'inboxclean.org',
  'inboxproxy.com',
  'incognitomail.com',
  'incognitomail.net',
  'incognitomail.org',
  'infocom.zp.ua',
  'insorg-mail.info',
  'instant-mail.de',
  'instantemailaddress.com',
  'ipoo.org',
  'irish2me.com',
  'iwi.net',
  'jetable.com',
  'jetable.fr.nf',
  'jetable.net',
  'jetable.org',
  'jnxjn.com',
  'jourrapide.com',
  'jsrsolutions.com',
  'junk1.com',
  'kasmail.com',
  'kaspop.com',
  'keepmymail.com',
  'killmail.com',
  'killmail.net',
  'kimsdisk.com',
  'kingsq.ga',
  'kiois.com',
  'klassmaster.com',
  'klassmaster.net',
  'klzlv.com',
  'kostenlosemailadresse.de',
  'koszmail.pl',
  'kulturbetrieb.info',
  'kurzepost.de',
  'lawlita.com',
  'letthemeatspam.com',
  'lhsdv.com',
  'lifebyfood.com',
  'link2mail.net',
  'litedrop.com',
  'lol.ovpn.to',
  'lookugly.com',
  'lopl.co.cc',
  'lortemail.dk',
  'lovemeleaveme.com',
  'lr78.com',
  'lroid.com',
  'lukop.dk',
  'm4ilweb.info',
  'maboard.com',
  'mail-hierarchie.net',
  'mail-temporaire.fr',
  'mail.by',
  'mail.mezimages.net',
  'mail.zp.ua',
  'mail114.net',
  'mail2rss.org',
  'mail333.com',
  'mail4trash.com',
  'mailbidon.com',
  'mailblocks.com',
  'mailbucket.org',
  'mailcat.biz',
  'mailcatch.com',
  'mailde.de',
  'mailde.info',
  'maildrop.cc',
  'maildrop.cf',
  'maildrop.ga',
  'maildrop.gq',
  'maildrop.ml',
  'maildu.de',
  'maildx.com',
  'mailed.ro',
  'maileater.com',
  'mailexpire.com',
  'mailfa.tk',
  'mailforspam.com',
  'mailfree.ga',
  'mailfree.gq',
  'mailfree.ml',
  'mailfreeonline.com',
  'mailguard.me',
  'mailhazard.com',
  'mailhazard.us',
  'mailhz.me',
  'mailimate.com',
  'mailin8r.com',
  'mailinater.com',
  'mailinator.com',
  'mailinator.gq',
  'mailinator.net',
  'mailinator.org',
  'mailinator.us',
  'mailinator2.com',
  'mailinblack.com',
  'mailincubator.com',
  'mailismagic.com',
  'mailjunk.cf',
  'mailjunk.ga',
  'mailjunk.gq',
  'mailjunk.ml',
  'mailjunk.tk',
  'mailmate.com',
  'mailme.gq',
  'mailme.ir',
  'mailme.lv',
  'mailme24.com',
  'mailmetrash.com',
  'mailmoat.com',
  'mailnator.com',
  'mailnesia.com',
  'mailnull.com',
  'mailorg.org',
  'mailpick.biz',
  'mailproxsy.com',
  'mailquack.com',
  'mailrock.biz',
  'mailsac.com',
  'mailscrap.com',
  'mailseal.de',
  'mailshell.com',
  'mailsiphon.com',
  'mailslapping.com',
  'mailslite.com',
  'mailspam.xyz',
  'mailsquad.com',
  'mailtemp.info',
  'mailtome.de',
  'mailtothis.com',
  'mailtrash.net',
  'mailtv.net',
  'mailtv.tv',
  'mailzilla.com',
  'mailzilla.org',
  'makemetheking.com',
  'malahov.de',
  'manifestgenerator.com',
  'manybrain.com',
  'mbx.cc',
  'mega.zik.dj',
  'meinspamschutz.de',
  'meltmail.com',
  'messagebeamer.de',
  'mezimages.net',
  'mierdamail.com',
  'migmail.pl',
  'migumail.com',
  'mintemail.com',
  'mjukgansen.nu',
  'moakt.com',
  'mobi.web.id',
  'mobileninja.co.uk',
  'moburl.com',
  'mohmal.com',
  'moncourrier.fr.nf',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'monumentmail.com',
  'ms9.mailslite.com',
  'msa.minsmail.com',
  'msb.minsmail.com',
  'msg.mailslite.com',
  'mspeciosa.com',
  'mswork.ru',
  'mt2009.com',
  'mt2014.com',
  'mtmdev.com',
  'muimail.com',
  'mvrht.net',
  'mx0.wwwnew.eu',
  'my10minutemail.com',
  'mycleaninbox.net',
  'myemailboxy.com',
  'mymail-in.net',
  'mymailoasis.com',
  'mynetstore.de',
  'mypacks.net',
  'mypartyclip.de',
  'myphantomemail.com',
  'myspaceinc.com',
  'myspaceinc.net',
  'myspacepimpedup.com',
  'myspamless.com',
  'mytempemail.com',
  'mytempmail.com',
  'mytrashmail.com',
  'nabuma.com',
  'neomailbox.com',
  'nepwk.com',
  'nervmich.net',
  'nervtmansen.de',
  'netmails.com',
  'netmails.net',
  'netzidiot.de',
  'neverbox.com',
  'nice-4u.com',
  'nincsmail.hu',
  'nmail.cf',
  'no-spam.ws',
  'nobulk.com',
  'noclickemail.com',
  'nogmailspam.info',
  'nomail.pw',
  'nomail.xl.cx',
  'nomail2me.com',
  'nomorespamemails.com',
  'nonspam.eu',
  'nonspammer.de',
  'noref.in',
  'nospam.ze.tc',
  'nospam4.us',
  'nospamfor.us',
  'nospammail.net',
  'nospamthanks.info',
  'notmailinator.com',
  'notsharingmy.info',
  'nowhere.org',
  'nowmymail.com',
  'ntlhelp.net',
  'nullbox.info',
  'nurfuerspam.de',
  'nus.edu.sg',
  'nwldx.com',
  'objectmail.com',
  'obobbo.com',
  'odnorazovoe.ru',
  'ohaaa.de',
  'omail.pro',
  'oneoffemail.com',
  'onewaymail.com',
  'onlatedotcom.info',
  'online.ms',
  'oopi.org',
  'opayq.com',
  'ordinaryamerican.net',
  'otherinbox.com',
  'ourklips.com',
  'outlawspam.com',
  'ovpn.to',
  'owlpic.com',
  'pancakemail.com',
  'pjjkp.com',
  'plexolan.de',
  'poczta.onet.pl',
  'politikerclub.de',
  'poofy.org',
  'pookmail.com',
  'privacy.net',
  'privatdemail.net',
  'privy-mail.com',
  'privymail.de',
  'proxymail.eu',
  'prtnx.com',
  'punkass.com',
  'putthisinyourspamdatabase.com',
  'pwrby.com',
  'q314.net',
  'qisdo.com',
  'qisoa.com',
  'qoika.com',
  'quickinbox.com',
  'quickmail.nl',
  'rainmail.biz',
  'rcpt.at',
  'reallymymail.com',
  'realtyalerts.ca',
  'recode.me',
  'recursor.net',
  'recyclemail.dk',
  'regbypass.com',
  'regbypass.comsafe-mail.net',
  'rejectmail.com',
  'reliable-mail.com',
  'remail.cf',
  'remail.ga',
  'rhyta.com',
  'rklips.com',
  'rmqkr.net',
  'royal.net',
  'rppkn.com',
  'rtrtr.com',
  's0ny.net',
  'safe-mail.net',
  'safersignup.de',
  'safetymail.info',
  'safetypost.de',
  'sandelf.de',
  'sayawaka-dea.info',
  'saynotospams.com',
  'schafmail.de',
  'schrott-email.de',
  'secretemail.de',
  'secure-mail.biz',
  'selfdestructingmail.com',
  'senseless-entertainment.com',
  'server.ms.gov',
  'services391.com',
  'sharedmailbox.org',
  'sharklasers.com',
  'shieldemail.com',
  'shiftmail.com',
  'shitmail.me',
  'shitmail.org',
  'shortmail.net',
  'shut.name',
  'shut.ws',
  'sibmail.com',
  'sinnlos-mail.de',
  'siteposter.net',
  'skeefmail.com',
  'slaskpost.se',
  'slopsbox.com',
  'slowslow.de',
  'smap.4nmv.ru',
  'smashmail.de',
  'smellfear.com',
  'snakemail.com',
  'sneakemail.com',
  'sneakmail.de',
  'snkmail.com',
  'sofimail.com',
  'sofort-mail.de',
  'softpls.asia',
  'sogetthis.com',
  'sohu.com',
  'solvemail.info',
  'soodonims.com',
  'spam.la',
  'spam.su',
  'spam4.me',
  'spamail.de',
  'spamavert.com',
  'spambob.com',
  'spambob.net',
  'spambob.org',
  'spambog.com',
  'spambog.de',
  'spambog.net',
  'spambog.ru',
  'spambox.info',
  'spambox.irishspringrealty.com',
  'spambox.us',
  'spamcannon.com',
  'spamcannon.net',
  'spamcero.com',
  'spamcon.org',
  'spamcorptastic.com',
  'spamcowboy.com',
  'spamcowboy.net',
  'spamcowboy.org',
  'spamday.com',
  'spamex.com',
  'spamfree.eu',
  'spamfree24.com',
  'spamfree24.de',
  'spamfree24.eu',
  'spamfree24.info',
  'spamfree24.net',
  'spamfree24.org',
  'spamgoes.in',
  'spamgourmet.com',
  'spamgourmet.net',
  'spamgourmet.org',
  'spamherelots.com',
  'spamhereplease.com',
  'spamhole.com',
  'spamify.com',
  'spaminator.de',
  'spamkill.info',
  'spaml.com',
  'spaml.de',
  'spamlot.net',
  'spammotel.com',
  'spamobox.com',
  'spamoff.de',
  'spamslicer.com',
  'spamspot.com',
  'spamstack.net',
  'spamthis.co.uk',
  'spamthisplease.com',
  'spamtrail.com',
  'spamtroll.net',
  'speed.1s.fr',
  'spikio.com',
  'spoofmail.de',
  'squizzy.de',
  'ssoia.com',
  'startkeys.com',
  'stinkefinger.net',
  'stop-my-spam.cf',
  'stop-my-spam.com',
  'stop-my-spam.ga',
  'stop-my-spam.ml',
  'stop-my-spam.tk',
  'streetwisemail.com',
  'stuffmail.de',
  'super-auswahl.de',
  'supergreatmail.com',
  'supermailer.jp',
  'superrito.com',
  'superstachel.de',
  'suremail.info',
  'svk.jp',
  'sweetxxx.de',
  'tafmail.com',
  'tagyourself.com',
  'talkinator.com',
  'tapchicuoihoi.com',
  'teewars.org',
  'teleworm.com',
  'teleworm.us',
  'temp-mail.org',
  'temp-mail.ru',
  'temp.emeraldwebmail.com',
  'temp.headstrong.de',
  'tempail.com',
  'tempalias.com',
  'tempe-mail.com',
  'tempemail.biz',
  'tempemail.co.za',
  'tempemail.com',
  'tempemail.net',
  'tempinbox.co.uk',
  'tempinbox.com',
  'tempmail.co',
  'tempmail.de',
  'tempmail.eu',
  'tempmail.it',
  'tempmail.net',
  'tempmail.us',
  'tempmail2.com',
  'tempmaildemo.com',
  'tempmailer.com',
  'tempmailer.de',
  'tempomail.fr',
  'temporarily.de',
  'temporaryemail.net',
  'temporaryemail.us',
  'temporaryforwarding.com',
  'temporaryinbox.com',
  'temporarymailaddress.com',
  'tempthe.net',
  'thanksnospam.info',
  'thankyou2010.com',
  'thc.st',
  'thelimestones.com',
  'thisisnotmyrealemail.com',
  'thismail.net',
  'thismail.ru',
  'throam.com',
  'throwam.com',
  'throwawayemailaddress.com',
  'throwawaymail.com',
  'tilien.com',
  'tittbit.in',
  'tmailinator.com',
  'tmail.ws',
  'toiea.com',
  'tokenmail.de',
  'toomail.biz',
  'topranklist.de',
  'tradermail.info',
  'trash-amil.com',
  'trash-mail.at',
  'trash-mail.com',
  'trash-mail.de',
  'trash-mail.ga',
  'trash-mail.gq',
  'trash-mail.ml',
  'trash-mail.tk',
  'trash2009.com',
  'trash2010.com',
  'trash2011.com',
  'trashbox.eu',
  'trashdevil.com',
  'trashdevil.de',
  'trashemail.de',
  'trashmail.at',
  'trashmail.com',
  'trashmail.de',
  'trashmail.me',
  'trashmail.net',
  'trashmail.org',
  'trashmail.ws',
  'trashmailer.com',
  'trashymail.com',
  'trashymail.net',
  'trbvm.com',
  'trbvn.com',
  'trickmail.net',
  'trillianpro.com',
  'tryalert.com',
  'turual.com',
  'twinmail.de',
  'twoweirdtricks.com',
  'tyldd.com',
  'uggsrock.com',
  'umail.net',
  'unmail.ru',
  'upliftnow.com',
  'uplipht.com',
  'uroid.com',
  'us.af',
  'valemail.net',
  'venompen.com',
  'veryrealemail.com',
  'viditag.com',
  'viewcastmedia.com',
  'viewcastmedia.net',
  'viewcastmedia.org',
  'viralplays.com',
  'vkcode.ru',
  'vmani.com',
  'vomoto.com',
  'vpn.st',
  'vsimcard.com',
  'vubby.com',
  'walala.org',
  'walkmail.net',
  'walkmail.ru',
  'webemail.me',
  'webm4il.info',
  'webuser.in',
  'wee.my',
  'weg-werf-email.de',
  'wegwerf-email-addressen.de',
  'wegwerf-emails.de',
  'wegwerfadresse.de',
  'wegwerfemail.com',
  'wegwerfemail.de',
  'wegwerfmail.de',
  'wegwerfmail.info',
  'wegwerfmail.net',
  'wegwerfmail.org',
  'wetrainbayarea.com',
  'wetrainbayarea.org',
  'wh4f.org',
  'whatiaas.com',
  'whatpaas.com',
  'whopy.com',
  'whtjddn.33mail.com',
  'whyspam.me',
  'wilemail.com',
  'willhackforfood.biz',
  'willselfdestruct.com',
  'winemaven.info',
  'wolfsmail.tk',
  'wollan.info',
  'worldspace.link',
  'wronghead.com',
  'wuzup.net',
  'wuzupmail.net',
  'wwwnew.eu',
  'xagloo.co',
  'xagloo.com',
  'xemaps.com',
  'xents.com',
  'xmaily.com',
  'xoxy.net',
  'yapped.net',
  'yep.it',
  'yogamaven.com',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.gq',
  'yopmail.net',
  'yourdomain.com',
  'ypmail.webarnak.fr.eu.org',
  'yuurok.com',
  'z1p.biz',
  'za.com',
  'zebins.com',
  'zebins.eu',
  'zehnminuten.de',
  'zehnminutenmail.de',
  'zetmail.com',
  'zippymail.info',
  'zoaxe.com',
  'zoemail.com',
  'zoemail.net',
  'zoemail.org',
  'zomg.info',
  'zxcv.com',
  'zxcvbnm.com',
  'zzz.com',
  'ffcfd.cfd',
];

/**
 * Check if an email domain is in the trusted list
 * @param domain - The email domain to check
 * @returns true if the domain is trusted
 */
function isTrustedDomain(domain: string): boolean {
  // Direct match
  if (TRUSTED_EMAIL_DOMAINS.includes(domain)) {
    return true;
  }

  // Check for educational/institutional domains (ends with .edu, .ac.uk, etc.)
  const eduPatterns = ['edu', 'ac.uk', 'ac.in', 'edu.au', 'edu.cn', 'edu.in', 'edu.sg', 'ac.jp', 'edu.my'];
  for (const pattern of eduPatterns) {
    if (domain.endsWith(`.${pattern}`) || domain === pattern) {
      return true;
    }
  }

  return false;
}

/**
 * Check if an email address uses a disposable email domain
 * @param email - The email address to check
 * @returns true if the email is from a disposable domain, false otherwise
 */
export function isDisposableEmail(email: string): boolean {
  if (!email || typeof email !== 'string') {
    return false;
  }

  const domain = email.toLowerCase().split('@')[1];
  if (!domain) {
    return false;
  }

  // First check if it's a trusted domain - always allow these
  if (isTrustedDomain(domain)) {
    return false;
  }

  // Then check if it's a known disposable domain
  return DISPOSABLE_EMAIL_DOMAINS.includes(domain);
}

/**
 * Get the error message for disposable email
 */
export function getDisposableEmailError(): string {
  return 'Please enter a valid email address.';
}
